import { render, staticRenderFns } from "./index.vue?vue&type=template&id=df29ec80&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df29ec80",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/data/jenkins/workspace/booking-fe-stg/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('df29ec80')) {
      api.createRecord('df29ec80', component.options)
    } else {
      api.reload('df29ec80', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=df29ec80&scoped=true&", function () {
      api.rerender('df29ec80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/App/VPL/MyOrder/OrderDetail/index.vue"
export default component.exports